<template>
    <div class="available-providers-item">
        <h4 class="fs-4 mt-0 mb-3">{{ provider.type }}</h4>

        <div class="provider-label">
            <div v-if="provider.icon" class="provider-label__icon">
                <component :is="'icon-' + provider.icon" />
            </div>
            <h5 class="provider-label__text m-0 bold">
                {{ provider.label }}
            </h5>
        </div>

        <p class="fs-3 mt-2 mb-3">{{ provider.description }}</p>
        <CompassButton
            :label="provider.button"
            :type="isGoogleAuthenticator(provider) ? 'primary' : 'secondary'"
            data-test="activate-2fa-provider-button"
            @click="activateProvider(provider)"
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        'icon-envelope': defineAsyncComponent(() => import('vcomponents/icons/IconEnvelope.vue')),
        'icon-google-authenticator': defineAsyncComponent(
            () => import('vcomponents/icons/IconGoogleAuthenticator.vue'),
        ),
        'icon-phone': defineAsyncComponent(() => import('vcomponents/icons/IconPhone.vue')),
    },
    props: {
        provider: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isGoogleAuthenticator() {
            return (provider) => {
                return provider.provider === 'google';
            };
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        activateProvider(provider) {
            this.open({
                key: 'activate2FAProvider',
                props: {
                    provider,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.available-providers-item {
    border: 1px solid $gray-40;
    border-radius: 4px;
    color: $gray-60;
    flex: 0 1 33%;
    padding: 16px;

    &:not(:first-child) {
        margin-left: 16px;
    }

    .provider-label {
        align-items: center;
        display: flex;

        &__icon {
            height: 24px;
            margin: 0 8px 0 0;
            width: 24px;
        }

        &__text {
            color: $gray-100;
        }
    }
}
</style>
